import React from "react";
import ReactPlayer from "react-player";
import * as S from "./styles";

export const Slide3: React.FC = () => {
  return (
    <S.Container>
      <S.Content className="left">
        <S.Wrapper>
          <S.Title>
            Lady Gaga <span>-</span> <br />
            ‘911’
          </S.Title>
          <S.Video>
            <ReactPlayer
              className="react-player"
              width="100%"
              height="100%"
              url="https://www.youtube.com/watch?v=58hoktsqk_Q"
            />
          </S.Video>
        </S.Wrapper>
      </S.Content>
      <S.Content className="right">
        <S.ContentWrapper>
          <S.Name>Duda Beat</S.Name>
          <S.Profile>Cantora</S.Profile>
          <S.Text>
            “Eu escolho o clipe de ‘911’, da Lady Gaga! Na verdade, amo todos os
            clipes da Gaga, mas esse último foi arrebatador, além de ter muitas
            referências dos trabalhos de Alejandro Jodorowsky, que é um dos meus
            cineastas favoritos.”
          </S.Text>
        </S.ContentWrapper>
      </S.Content>
    </S.Container>
  );
};
